<template>
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>展品</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展品</div>
        <div class="search-filters">
          <div class="search-list">
            <div
              class="search-row"
              v-for="(item, index) in searchList"
              :key="item.id"
            >
              <Select
                v-model="item.type"
                style="width: 100px"
                @on-change="onSearchTypeChange(index)"
              >
                <Option
                  v-for="opt in getAvailableTypes(item)"
                  :value="opt.value"
                  :key="opt.value"
                  >{{ opt.label }}</Option
                >
              </Select>
              <Input
                v-if="item.type === 'Name'"
                placeholder="请输入关键字"
                v-model="item.value"
                style="width: 360px"
              />
              <Input
                v-else-if="item.type === 'ExArea'"
                placeholder="请输入展区"
                v-model="item.value"
                style="width: 360px"
              />
              <el-cascader
                v-else-if="item.type === 'leibie'"
                v-model="item.value"
                :options="categoryList"
                :props="categoryProps"
                clearable
                collapse-tags
                placeholder="输入关键词进行类别搜索"
                style="width: 360px"
              />
              <Cascader
                v-else-if="item.type === 'TagName'"
                :key="'tag-' + ProTagList.length"
                v-model="item.value"
                :data="ProTagList"
                filterable
                clearable
                placeholder="输入关键词进行标签搜索"
                style="width: 360px"
              />
              <Icon
                type="ios-add-circle-outline"
                v-if="index === 0"
                @click="addSearch()"
                style="color: #2d8cf0; font-size: 20px; cursor: pointer; margin-left: 8px"
              />
              <Icon
                type="ios-remove-circle-outline"
                v-if="index > 0"
                style="color: red; font-size: 20px; cursor: pointer; margin-left: 8px"
                @click="delSearch(index)"
              />
            </div>
          </div>
          <Button class="search-btn" type="primary" @click="searchPro()" style="margin-left: 10px">搜索</Button>
        </div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="downloadSearchEnd">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出搜索结果</span>
        </div>
        <div class="htb-item" @click="$router.push('/host/index/pro/pro-export')">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出展品</span>
        </div>
      </div>
    </div>
    <hostProductItem ref="hostProductItem" :searchQuery="searchQuery" />
  </div>
</template>

<script>
import hostProductItem from "../components/host-product-item.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "host-product",
  data() {
    return {
      company: null,
      editId: "",
      addBrandflag: false,
      showTabs: "1",
      cityList: [
        {
          value: "Name",
          label: "产品名",
        },
        {
          value: "TagName",
          label: "展品标签",
        },
        {
          value: "leibie",
          label: "产品类别",
        },
        {
          value: "ExArea",
          label: "展区",
        },
      ],
      searchList: [
        {
          id: 1,
          type: "Name",
          value: "",
        },
      ],
      searchId: 1,
      searchQuery: {},
      categoryList: [],
      ProTagList: [],
      categoryProps: {
        multiple: true,
        checkStrictly: true,
        value: "value",
        label: "label",
        children: "children",
        emitPath: true,
      },
    };
  },
  components: {
    hostProductItem,
  },
  async created() {
    this.loadFilterOptions();
  },
  computed: {
    ...mapGetters({
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current",
      hostExhibition: "hostSetModule/getHostExhibition",
    }),

    query() {
      return this.$route.query;
    },
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`,
                },
              },
            ],
          },
        },
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapMutations({
      refushPageInfo: "productModule/refushPageInfo",
      refushWheres: "productModule/refushWheres",
      refushCurrent: "productModule/refushCurrent",
    }),
    ...mapActions({
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      getList: "productModule/getList",
      addProduct: "productModule/addProduct",
      add: "productModule/add",
      edit: "productModule/edit",
      getOne: "productModule/getOne",
      remove: "productModule/remove",
      addTask: "hostCommonModule/addTask",
      getProductByGroupId: "categoryModule/getProductByGroupId",
      getProTag: "companyInfoModule/getProTag",
    }),
    getAvailableTypes(currentItem) {
      const used = this.searchList
        .filter((item) => item !== currentItem)
        .map((item) => item.type);
      return this.cityList.filter((opt) => !used.includes(opt.value));
    },
    emptyValueByType(type) {
      return type === "TagName" || type === "leibie" ? [] : "";
    },
    onSearchTypeChange(index) {
      const type = this.searchList[index].type;
      this.$set(this.searchList[index], "value", this.emptyValueByType(type));
      if (type === "leibie" && !this.categoryList.length) {
        this.loadCategories();
      }
      if (type === "TagName" && !this.ProTagList.length) {
        this.loadTags();
      }
    },
    addSearch() {
      const used = this.searchList.map((item) => item.type);
      const next = this.cityList.find((opt) => !used.includes(opt.value));
      if (!next) {
        this.$Message.info("已添加全部筛选条件");
        return;
      }
      this.searchId += 1;
      this.searchList.push({
        id: this.searchId,
        type: next.value,
        value: this.emptyValueByType(next.value),
      });
    },
    delSearch(index) {
      this.searchList.splice(index, 1);
    },
    getCascaderLabel(list, values) {
      if (!list || !values || !values.length) return "";
      let nodes = list;
      let labels = [];
      values.forEach((val) => {
        const node = (nodes || []).find((n) => n.value === val);
        if (node) {
          labels.push(node.label);
          nodes = node.children;
        }
      });
      return labels.length ? labels[labels.length - 1] : "";
    },
    pathToCategoryCondition(path) {
      const p = Array.isArray(path) ? path : [path];
      return {
        Level1: p[0] || null,
        Level2: p[1] || null,
        Level3: p[2] || null,
      };
    },
    buildQuery() {
      const q = {};
      this.searchList.forEach((item) => {
        if (item.type === "Name") {
          const name = (item.value || "").trim();
          if (name) q.Name = name;
        } else if (item.type === "TagName" && Array.isArray(item.value) && item.value.length) {
          const tagName = this.getCascaderLabel(this.ProTagList, item.value);
          if (tagName) q.TagName = tagName;
        } else if (item.type === "leibie" && Array.isArray(item.value) && item.value.length) {
          q.CategoryConditions = item.value.map(this.pathToCategoryCondition);
        } else if (item.type === "ExArea") {
          const exArea = (item.value || "").trim();
          if (exArea) q.ExArea = exArea;
        }
      });
      return q;
    },
    async loadTags() {
      let ProTagData = await this.getProTag();
      if (ProTagData && ProTagData.length) {
        ProTagData.forEach((c) => {
          c.value = c.id;
          c.label = c.name;
          c.children = JSON.parse(JSON.stringify(c.list || []));
          (c.children || []).forEach((v) => {
            v.value = v.id;
            v.label = v.name;
            v.children = JSON.parse(JSON.stringify(v.list || []));
            (v.children || []).forEach((z) => {
              z.value = z.id;
              z.label = z.name;
              z.children = JSON.parse(JSON.stringify(z.list || []));
            });
          });
        });
        this.ProTagList = ProTagData;
      } else {
        this.ProTagList = [];
      }
    },
    async loadCategories() {
      const groupId =
        (this.hostExhibition && this.hostExhibition.groupId) ||
        (this.exhibitionInfo && this.exhibitionInfo.groupId);
      if (!groupId) {
        this.categoryList = [];
        return;
      }
      let categoryData = await this.getProductByGroupId({
        groupId,
        level: 0,
        loadChild: true,
      });
      if (categoryData && categoryData.length) {
        const mapNode = (node) => {
          node.value = node.id;
          node.label = node.name;
          const list = node.list || [];
          if (list.length) {
            node.children = JSON.parse(JSON.stringify(list)).map(mapNode);
          } else {
            delete node.children;
          }
          return node;
        };
        this.categoryList = categoryData.map(mapNode);
      } else {
        this.categoryList = [];
      }
    },
    loadFilterOptions() {
      this.loadTags();
      this.loadCategories();
    },
    searchPro() {
      this.searchQuery = this.buildQuery();
      this.$nextTick(() => {
        this.$refs.hostProductItem.reload();
      });
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    },
      async downloadSearchEnd () {
        let textExport="产品表格搜索结果和图片导出"
        this.searchQuery = this.buildQuery()
      let req = {
        "taskType": 0,
        "taskName": this.exhibitionInfo.name + textExport,
        "exhibitionId": this.exhibitionInfo.id,
        'searchCondition':JSON.stringify(this.searchQuery)
      }
      let bool = await this.addTask(req);
      if (bool && bool.successed) {
        this.$Message.success("创建成功！");
        this.$router.push('/host/index/pro/pro-export')
      } else {
        this.$Message.success("创建失败，请重新尝试");
      }
    }
  },
};
</script>

<style scoped lang="scss">
.search-filters {
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
}
.search-btn {
  background-color: #2d8cf0 !important;
  border-color: #2d8cf0 !important;
  color: #fff !important;
}
.search-btn:hover,
.search-btn:focus {
  background-color: #57a3f3 !important;
  border-color: #57a3f3 !important;
  color: #fff !important;
}
.search-list {
  display: flex;
  flex-direction: column;
}
.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  /deep/ .el-cascader {
    height: 32px;
    line-height: 32px !important;
    font-size: 14px;
    vertical-align: top;
    .el-input {
      height: 32px;
      font-size: 14px;
    }
    .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
      padding: 0 7px !important;
    }
  }
}
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
